exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* Global css */\n.zoombtn {\n  margin-top: 20px; }\n  .zoombtn a:first-child {\n    margin-right: 10px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/Components/Dragzone/style.scss
// module id = 300
// module chunks = 0